import React from "react";
import {
  Box,
  Button,
  Flex,
  Text,
  Badge,
  Image,
  VStack,
  HStack,
} from "@chakra-ui/react";
import { BIZFLEX_README_DOCS_BASE } from "../../components/common/constants";
import usePageTitle from "../../utils/usePageTitle";

const ApiServices = () => {
  usePageTitle(
    "Financial API Services for Businesses & Developers | BizFlex",
    "BizFlex API services help businesses and developers build, manage, and scale financial products with secure and flexible APIs."
  ); 
  return (
    <Box
      color="#fff"
      fontFamily="Poppins"
      position="relative"
      w="100%"
      mt={{ base: "50px", md: "80px" }}
      pb={{ base: "80px", md: "120px" }}
    >
      <Flex
        align={{ base: "stretch", md: "flex-start" }}
        gap={{ base: "40px", md: "60px" }}
        position="relative"
        flexDir={{ base: "column", md: "row" }}
        justifyContent="space-between"
      >
        {/* Left Content */}
        <Box
          w={{ base: "100%", md: "52%" }}
          position="relative"
          zIndex={2}
        >
          {/* Badge */}
          <Badge
            display="flex"
            alignItems="center"
            gap="8px"
            w="fit-content"
            color="#2463EB"
            px="16px"
            py="8px"
            borderRadius="20px"
            fontSize="12px"
            fontWeight={500}
            mb="32px"
          >
            <Image src="/assets/Star2.svg" alt="star" w="16px" h="16px" color="#2463EB" />
            Trusted by 500+ African Businesses
          </Badge>

          {/* Main Heading */}
          <Text
            as="h2"
            fontSize={{ base: "36px", md: "64px" }}
            fontWeight={700}
            lineHeight={{ base: "43.2px", md: "76.8px" }}
            mb="24px"
            color="#fff"
          >
            Seamless Financial Infrastructure for{" "}
            <span style={{ color: "#FF9D16" }}>Africa</span>
          </Text>

          {/* Description */}
          <Text
            fontSize={{ base: "14px", md: "18px" }}
            lineHeight={{ base: "21px", md: "27px" }}
            color="#dcdcdc"
            mb="40px"
            maxW="600px"
          >
            BizFlex Africa provides businesses and developers with APIs to
            create, manage, and scale financial products – from payments and
            wallets to cross-border transactions. We simplify complex financial
            infrastructure so you can focus on growth.
          </Text>

          {/* CTA Buttons */}
          <Flex
            gap="16px"
            flexDir={{ base: "column", md: "row" }}
            mb="60px"
          >
            <Button
              as="a"
              href={BIZFLEX_README_DOCS_BASE}
              target="_blank"
              rel="noopener noreferrer"
              bg="#2463EB"
              borderRadius="12px"
              h="52px"
              w={{ base: "100%", md: "240px" }}
              color="#fff"
              fontWeight={400}
              fontSize="14px"
              display="flex"
              alignItems="center"
              justifyContent="center"
              gap="8px"
              _hover={{ bg: "#1a4fc7" }}
            >
              See API Documentation
              <Image
                src="/assets/arrow-right.svg"
                alt="arrow"
                w="17px"
                h="17px"
              />
            </Button>
            <Button
              variant="outline"
              borderRadius="12px"
              h="52px"
              w={{ base: "100%", md: "220px" }}
              color="#fff"
              fontWeight={400}
              fontSize="14px"
              border="1px solid rgba(255, 255, 255, 0.4)"
              display="flex"
              alignItems="center"
              justifyContent="center"
              gap="8px"
              _hover={{ bg: "rgba(255, 255, 255, 0.08)", borderColor: "rgba(255, 255, 255, 0.6)" }}
            >
              Create Business Account
              <Image
                src="/assets/personalcard.svg"
                alt="card"
                w="20px"
                h="20px"
              />
            </Button>
          </Flex>

          {/* Feature Highlights */}
          <Flex
            gap={{ base: "24px", md: "48px" }}
            flexDir={{ base: "column", md: "row" }}
          >
            <VStack align="flex-start" spacing="0px">
              <HStack spacing="6px" align="center">
                <Image
                  src="/assets/shield.svg"
                  alt="shield"
                  w="24px"
                  h="24px"
                />
                <Text fontSize="14px" color="#dcdcdc" fontWeight={500}>
                  Bank-grade Security
                </Text>
              </HStack>
              <Text fontSize="12px" color="#dcdcdc" pl="32px">
                NDPR Compliant
              </Text>
            </VStack>
            <VStack align="flex-start" spacing="0px">
              <HStack spacing="6px" align="center">
                <Image
                  src="/assets/mingcuteflash.svg"
                  alt="lightning"
                  w="24px"
                  h="24px"
                />
                <Text fontSize="14px" color="#dcdcdc" fontWeight={500}>
                  99.9% Uptime
                </Text>
              </HStack>
              <Text fontSize="12px" color="#dcdcdc" pl="32px">
                Always Available
              </Text>
            </VStack>
          </Flex>
        </Box>

        {/* Right Content - API Marketplace */}
        <Box
          w={{ base: "100%", md: "45%" }}
          position={{ base: "relative", md: "absolute" }}
          right="0"
          top="60px"
          zIndex={2}
          display="flex"
          alignItems="center"
          justifyContent={{ base: "center", md: "flex-end" }}
        >
          <Image
            src="/assets/Api-market-place.svg"
            alt="API marketplace"
            w="100%"
            maxW="600px"
            h="auto"
            objectFit="contain"
          />
        </Box>
      </Flex>
    </Box>
  );
};

export default ApiServices;

